"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.choose = exports.getFromEnvOrThrow = void 0;
const log = require("loglevel");
function getFromEnvOrThrow(env) {
    const result = process.env[env];
    if (result === null || result === undefined || result.trim() === '') {
        throw new Error(`${env} unset in environment!`);
    }
    log.debug(`Using ${env} = ${result}`);
    return result;
}
exports.getFromEnvOrThrow = getFromEnvOrThrow;
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function choose(choices) {
    const index = Math.floor(Math.random() * choices.length);
    return choices[index];
}
exports.choose = choose;
async function sleep(millis) {
    await new Promise(resolve => setTimeout(resolve, millis));
}
exports.sleep = sleep;
